import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PortalLayout from './components/PortalLayout';
import LoginScreen from './screens/LoginScreen';
import SystemHealthScreen from './screens/SystemHealthScreen';
import TargetsScreen from './screens/TargetsScreen';
import JobsScreen from './screens/JobsScreen';
import OpsWallboard from './screens/OpsWallboard';

function RequireAuth({ children }: { children: React.ReactElement }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

function LoginGate() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/ops" replace /> : <LoginScreen />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LoginGate />} />
          <Route path="/ops" element={<RequireAuth><OpsWallboard /></RequireAuth>} />
          <Route path="/health" element={<RequireAuth><PortalLayout><SystemHealthScreen /></PortalLayout></RequireAuth>} />
          <Route path="/targets" element={<RequireAuth><PortalLayout><TargetsScreen /></PortalLayout></RequireAuth>} />
          <Route path="/jobs" element={<RequireAuth><PortalLayout><JobsScreen /></PortalLayout></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
